﻿import { Config, ErrorHandling } from "@serenity-is/corelib";

Config.rootNamespaces.push('FitnessSvrBOLEAD');
//Config.responsiveDialogs = true;

if ($.fn['colorbox']) {
    $.fn['colorbox'].settings.maxWidth = "95%";
    $.fn['colorbox'].settings.maxHeight = "95%";
}

//window.onload = function () {
//    document.querySelectorAll("input.editor").forEach(el => el.setAttribute("autocomplete", "off"));
//};
//@ts-ignore
//var vConsole = new window.VConsole();
window.onerror = ErrorHandling.runtimeErrorHandler;